import { Link } from '@routable/gross-ds';
import React from 'react';
import { Hint, HintText } from 'components/hint';
import helpDocs from 'helpers/helpDocs';
const MissingPartnerCountryHint = () => (React.createElement(Hint, { intent: "info", multiline: true },
    React.createElement(HintText, null,
        "Can't find your country? Learn more about",
        ' ',
        React.createElement(Link, { href: helpDocs.PARTNER_COUNTRY_CURRENCY_HINT, openInNewTab: true }, "supported countries and currencies"))));
export default MissingPartnerCountryHint;
